import classnames from 'classnames'
import Icon from 'components/shared/Icon/Icon'
import PropTypes from 'prop-types'
import React, { useEffect, useState } from 'react'
import { withNamespaces } from 'react-i18next'
import { useSearchParams } from 'react-router-dom'

import './Search.scss'

export const Search = ({ className, location, placeholder = '', t }) => {
  const [searchParams, setSearchParams] = useSearchParams()
  const [searchTerm, setSearchTerm] = useState(searchParams.get('search') || '')

  useEffect(() => {
    if (searchParams.get('search')) {
      setSearchTerm(searchParams.get('search'))
    } else {
      setSearchTerm('')
    }
  }, [location, searchParams])

  const changeHandler = () => {
    setSearchParams({ search: searchTerm })
  }

  const keyHandler = (event) => {
    if (event.key === 'Enter') {
      changeHandler()
    }
  }

  const resetSearch = () => {
    setSearchTerm('')
    searchParams.delete('search')
    setSearchParams(searchParams)
  }

  const closeProps = {
    ...(searchTerm !== '' && {
      onClick: () => resetSearch(),
      onKeyPress: (event) => {
        if (event.key === 'Enter') {
          resetSearch()
        }
      },
      tabIndex: 0,
    }),
  }

  return (
    <div className={classnames('.c-search__border', className)}>
      <div className="c-search">
        <input
          className="c-search__input"
          type="text"
          name="search"
          value={searchTerm}
          placeholder={placeholder}
          onChange={(e) => setSearchTerm(e.target.value)}
          onKeyPress={keyHandler}
          autoComplete="off"
        />
        <div
          alt=""
          className={classnames('c-search__icon', {
            'c-search__close_icon_hide': searchTerm === '',
          })}
          role="button"
          aria-label={t('filter.closeIconLabel')}
          {...closeProps}
        >
          <Icon type="cross" className="c-search__close_icon" />
        </div>
        <div
          className={classnames('c-search__button', {
            'c-search__button_invert': searchTerm !== '',
          })}
        >
          <div
            alt=""
            className="c-search__icon"
            onClick={changeHandler}
            onKeyPress={keyHandler}
            role="button"
            aria-label={t('filter.searchIconLabel')}
            tabIndex={0}
          >
            <Icon type="magnifying-glass" className="c-search__search_icon" />
          </div>
        </div>
      </div>
    </div>
  )
}

Search.propTypes = {
  className: PropTypes.string,
  placeholder: PropTypes.string,
  location: PropTypes.object,
  t: PropTypes.func.isRequired,
}

export default withNamespaces('translations')(Search)
